import OrgScopedPage from "./OrgScopedPage";
import FlowBuilder from "../FlowBuilder/FlowBuilder";

/**
 * PlatformFlows — super-admin Flow Builder page. Reuses the exact tenant Flow
 * Builder (flow list + visual editor) scoped to the selected organization.
 */
export default function PlatformFlows() {
    return (
        <OrgScopedPage title="Flow Builder" subtitle="Design an organization's conversation flows.">
            <FlowBuilder />
        </OrgScopedPage>
    );
}
